import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any[] = []

const donutViewByItemsSlices = createSlice({
  name: 'DonutViewByItems',
  initialState,
  reducers: {
    setDonutViewByItems(state, action: PayloadAction<any[]>) {
      return action.payload ?? initialState
    },
  },
})

export const { setDonutViewByItems } = donutViewByItemsSlices.actions

export default donutViewByItemsSlices.reducer
